import React from 'react';
import propTypes from 'prop-types';

const { shape, string } = propTypes;

function ProfileBox ({ title, line1, line2 }) {

	return (
		<section className='profile-box'>
			<h1>{title}</h1>
			<p id={line1.id}>{line1.display}</p>
			<p id={line2.id}>{line2.display}</p>
		</section>
	);
}

ProfileBox.propTypes = {
	title: string.isRequired,
	line1: shape({
		display: string.isRequired,
		id: string.isRequired
	}),
	line2: shape({
		display: string.isRequired,
		id: string.isRequired
	})
};

export default ProfileBox;
